export function knowledgeTargetKey(type: string, slug: string): string {
  return `${type}:${slug}`;
}

export function knowledgeArticlePath(type: string, slug: string): string {
  return `/knowledge/${encodeURIComponent(type)}/${encodeURIComponent(slug)}`;
}
